import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid'
import $ from 'jquery'
import ReCAPTCHA from "react-google-recaptcha";

import Parser from 'html-react-parser';

// Sasssrc\Components\Organisms\Empresas\CE41\index.js
 import '../../../../Sass/includes/Components/modules/CE41.sass'

import { RegisterRequestService } from 'actions/HttpCalls'
import { HttpClient } from 'actions/HttpClient'
import { validForm } from 'constants/validFuntions'

const httpClient = new HttpClient();
const registerRequestService = new RegisterRequestService(httpClient);

const STATUS = {
	STEPS: "steps",
	SUCCESS: "success",
	APPLICATION: "application",

}

var today = new Date();
var maxDate = `${today.getFullYear() + 2}-${String(today.getMonth() + 3).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
var minDate = `${today.getFullYear() - 93}-${String(today.getMonth() + 3).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
const SITE_KEY = "6LcrQLEeAAAAAP9jjwF8j2Wc0kGl6bxm3DcKd56c";

function getStepInfo(stepIndex, dataConfig) {

	switch (stepIndex) {
		case 0:
			return <div className="ce41BoxStepsInfo">
						<i className="ico-archive"></i>
						{dataConfig?.title_BOX_1 && <h3>
							<span>Paso 1 </span>
							{Parser(dataConfig.title_BOX_1)}
						</h3>}
						{dataConfig?.description_BOX_1 && <p>{Parser(dataConfig.description_BOX_1)}</p>}
					</div>;
		case 1:
			return <div className="ce41BoxStepsInfo">
						<i className="ico-shopping-bag"></i>
						{dataConfig?.title_BOX_2 && <h3>
							<span>Paso 2 </span>
							{Parser(dataConfig.title_BOX_2)}
						</h3>}
						{dataConfig?.description_BOX_2 && <p>{Parser(dataConfig.description_BOX_2)}</p>}
					</div>;
		case 2:
			return <div className="ce41BoxStepsInfo">
						<i className="ico-archive"></i>
						{dataConfig?.title_BOX_3 && <h3>
							<span>Paso 3 </span>
							{Parser(dataConfig.title_BOX_3)}
						</h3>}
						{dataConfig?.description_BOX_3 && <p>{Parser(dataConfig.description_BOX_3)}</p>}
					</div>;
		case 3:
			return <div className="ce41BoxStepsInfo">
						<i className="ico-file-text"></i>
						{dataConfig.title_BOX_4 && <h3>
							<span>Paso 4 </span>
							{Parser(dataConfig.title_BOX_4)}
						</h3>}
						{dataConfig?.description_BOX_4 && <p>{Parser(dataConfig.description_BOX_4)}</p>}
					</div>;
		case 4:
			return <div className="ce41BoxStepsInfo">
						<i className="ico-file-text"></i>
						{dataConfig?.title_BOX_5 && <h3>
							<span>Paso 5 </span>
							{Parser(dataConfig.title_BOX_5)}
						</h3>}
						{dataConfig.description_BOX_5 && <p>{Parser(dataConfig.description_BOX_5)}</p>}
					</div>;
		default:
			return "No Content";
	}
}

const _renderPlanes = (planes, idPlanSelected, setIdPlanSelected) => (
	planes ?
		planes.map((plan, index) => (
			<div className="ce41BoxRadio" key={uuid()}>
				<input 
					type="radio"
					name="rad1" 
					value={plan.fi_plan}
					onChange={e => { setIdPlanSelected(parseInt(e.target.value)); $('errornamePlan').hide() }} 
					checked={plan.fi_plan === idPlanSelected ? true : false}
					/>
				<span className="checkbg"></span>
				<span className="checkmark"></span>
				<div className="ce41BoxRadioInner">
					<h3>{plan.fc_precio} - {plan.fc_nombre}</h3>
					<p>
						{
							plan?.fc_detalle ? Parser(plan.fc_detalle) : null
						}
					</p>
				</div>
			</div>
		))
		:
		<>
			<div>Cargando...</div>
		</>
)

function getStepContent(stepIndex, dataConfig, txtTerms5, dataOfBanks, dataPlanes, dataDocumentTypes, dataDepartments, dataEntities, dataOperators, 
		localTelefono, validateOnlyNumbersComparador,
		nameUser,
		setNameUser,
		phoneUser,
		setNumberValid,
		idDocumentType,
		setIdDocumentType,
		noDocument,
		setNumberValidDocument,
		emailUser,
		setEmailUser,
		birthDateUser,
		setBirthDateUser,
		expediDataUser,
		setExpediDataUser,
		nit,
		setNit,
		insertSimCar,
		setInsertSimCar,
		nombreEmpleado,
		setNombreEmpleado,
		cedulaEmpleado,
		setCedulaEmpleado,
		camaraComercio,
		setCamaraComercio,
		addressUser,
		setAddressUser,
		cityUser,
		setCityUser,
		idDeparment,
		setIdDeparment,
		barrioUser,
		setBarrioUser,
		parentesco,
		setParentesco,
		otherParent,
		setOtherParent,
		idPlanSelected,
		setIdPlanSelected,
		typeModalidad,
		radiosModality,
		operatorSelected, setOperatorSelected,
		fc_tipo_sim, setFcTipoSim,
		entitySelected, setEntitySelected,
		fiAutDescuentoNom, setFiAutDescuentoNom,
		fiAceptaContrato, setFiAceptaContrato,
		setCaptchaValue,
		fiFactElec, setFiFactElec,
		handleSubmit,
		idBanco,
	) {

	const optionsDocumentType = dataDocumentTypes?.length ? dataDocumentTypes.map((docT, index) => (
		<option key={uuid()} value={docT.fi_id} >{docT.fc_descripcion}</option>
	)) : null

	const optionsDeparments = dataDepartments?.length ? dataDepartments.map((dep, index) => (
		<option key={uuid()} value={dep.fi_id} >{dep.fc_descripcion}</option>
	)) : null

	const optionsEntities = dataEntities?.length ? dataEntities.map((dep, index) => (
		<option key={uuid()} value={dep.fi_id} >{dep.fc_descripcion}</option>
	)) : null

	const optionsOperators = dataOperators?.length ? dataOperators.map((dep, index) => (
		<option key={uuid()} value={dep.fi_id} >{dep.fc_descripcion}</option>
	)) : null

	const modalidadNormalizada = (typeModalidad || "")
		.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");

		const esModalidadAdicional =
		modalidadNormalizada !== "" &&
		!["linea nueva", "inclusion", "portabilidad"].some(
			modalidad => modalidadNormalizada.includes(modalidad)
		);

		const mostrarDatosEmpleado =
			idBanco === 7 ||
			(idBanco === 5 && esModalidadAdicional) ||
			(idBanco !== 5 && idBanco !== 7);

			
	switch (stepIndex) {
		case 0:
			return <div className="ce41BoxProcessInner">
					<form onSubmit={handleSubmit} name="formUserInfo">
					<div className="fsTwoCols">
					{(idBanco === 3 || idBanco === 1) ? (
						<fieldset><label>Nombres y Apellidos</label>
							<input type="text" value={nameUser} onChange={(e) => { const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/; if (regex.test(e.target.value)) { setNameUser(e.target.value); } }} name="nameUser" id="nameUser" placeholder="Escriba su nombre " required/>
						</fieldset>
					) : (
						<fieldset>
							<label>Nombre</label>
							<input  type="text" value={nameUser} onChange={(e) => { const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/; if (regex.test(e.target.value)) { setNameUser(e.target.value); } }} name="nameUser" id="nameUser" placeholder="Escriba su nombre" required/>
						</fieldset>
					)}

						{(idBanco === 5 || idBanco === 7) ? (
  									<fieldset>
    									<label>Número de celular a incluir en el convenio</label>
    									<input type="text" value={phoneUser} onChange={e => setNumberValid(e.target.value)} maxLength={10} minLength={10} name="phoneUser" id="phoneUser" placeholder="Escriba su número de telefono" required/>
  									</fieldset>
						) : (
	  								<fieldset>
    									<label>Número de Celular</label>
    										<input type="text" value={phoneUser} onChange={e => setNumberValid(e.target.value)} maxLength={10} minLength={10} name="phoneUser" id="phoneUser" placeholder="Escriba su número de telefono" required/>
                                    </fieldset>
						)}



					</div>
					<div className="fsTwoCols">
						<fieldset>
							<label>Tipo de Documento</label>
							<span className="select">
								<select value={idDocumentType} onChange={e=>{setIdDocumentType(parseInt(e.target.value))}} name='idDocumentType' id='idDocumentType' required>
									<option value="" disabled>Seleccionar</option>
									{optionsDocumentType}
								</select>
							</span>
						</fieldset>
						<fieldset>
							<label>Número de Documento</label>
							<input type="text" value={noDocument} onChange={e=>{setNumberValidDocument(e.target.value)}} maxLength={15} name='noDocument' id='noDocument' placeholder="Escriba el número de identificación" required/>
						</fieldset>
					</div>
					<div className="fsTwoCols">
						{/* cambio Campo Correo id 7 no sale demas ids si sale en el primer paso */}
						{(idBanco === 7) ? (
							<fieldset style={{ display: "none" }}>
								<label>Correo Electrónico Corporativo</label>
								<input type="email" value={emailUser} onChange={e => { setEmailUser(e.target.value) }} maxLength={50} name='emailUser' id='emailUser' placeholder="ejemplo@banco.com" />
							</fieldset>
						) : (
							<fieldset>
								<label>Correo Electrónico Corporativo</label>
								<input type="email" value={emailUser} onChange={e => { setEmailUser(e.target.value) }} maxLength={50} name='emailUser' id='emailUser' placeholder="ejemplo@banco.com" required />
							</fieldset>
						)}

						<fieldset>
							<label>Fecha de Nacimiento</label>
							<input type="date" value={birthDateUser} min={minDate} max={maxDate} onChange={e => { setBirthDateUser(e.target.value) }} name='birthDateUser' id='birthDateUser' placeholder="Día / Mes / Año" required />
						</fieldset>
					</div>
					<h3 className="middleTitle">Domicilio</h3>
					<div className="fsTwoCols">
						<fieldset>
							<label>Dirección de Residencia</label>
							<input type="text" value={addressUser} onChange={e=>{setAddressUser(e.target.value)}} maxLength={100} name='addressUser' id='addressUser' placeholder="Escriba su dirección" required/>
						</fieldset>
						<fieldset>
							<label>Ciudad / Municipio</label>
							<input type="text" value={cityUser} onChange={e=>{setCityUser(e.target.value)}} maxLength={100} name='cityUser' id='cityUser' placeholder="Escriba su ciudad" required/>
						</fieldset>
					</div>
					<div className="fsTwoCols">
						<fieldset>
							<label>Departamento</label>
							<span className="select">
								<select value={idDeparment} onChange={e=>{setIdDeparment(parseInt(e.target.value))}} name='idDeparment' id='idDeparment' required>
									<option value="" disabled>Seleccionar</option>
									{optionsDeparments}
								</select>
							</span>
						</fieldset>
						<fieldset>
							<label>Barrio</label>
							<input type="text" value={barrioUser} onChange={e=>{setBarrioUser(e.target.value)}} maxLength={100} name='barrioUser' id='barrioUser' placeholder="Escriba su barrio" required/>
						</fieldset>
						
					</div>
					{ /* Ajuste fecha expedicion */ }
					<div  className="fsTwoCols">
					{dataConfig.visible_INPUT_FECHA_EXPEDICION === 'true' ? (
  						(idBanco === 7 || idBanco === 5 || idBanco === 4) ? (
    						<fieldset>
      							<label>Fecha de expedición de la cédula</label>
      							<input type="date" value={expediDataUser} min={minDate} max={maxDate} onChange={e => setExpediDataUser(e.target.value)} name="expediDataUser" id="expediDataUser" placeholder="Día / Mes / Año" required/>
    						</fieldset>
  					) : (
    					<fieldset>
      						<label>Fecha de Expedición</label>
      						<input type="date" value={expediDataUser} min={minDate} max={maxDate} onChange={e => setExpediDataUser(e.target.value)} name="expediDataUser" id="expediDataUser" placeholder="Día / Mes / Año" required/>
    					</fieldset>
  						)
					) : null}

					    {
							dataConfig.visible_INPUT_CAMARA_COMERCIO  === 'true' ?
								<fieldset>
									<label>Cámara de comercio</label>
									<input type="text" value={camaraComercio} onChange={e=>{setCamaraComercio(e.target.value)}} maxLength={15} name='camaraComercio' id='camaraComercio' placeholder="Cámara de comercio"required/>
								</fieldset>
							:null
						}
						
					</div>
					{
						dataOfBanks[0]?.fc_descripcion.toLowerCase().indexOf("davivienda") > 0 &&
						<>
							<h3 className="middleTitle">Familiares beneficiarios</h3>
							<div className="fsTwoCols">
								<fieldset>
									<label>Selecciona el parentesco</label>
									<span className="select">
										<select value={parentesco} onChange={e=>{setParentesco(e.target.value)}} id="parentesco" name="parentesco" required>
											<option value="" disabled>Seleccionar</option>
											<option value="Padres">Padres</option> 
											<option value="Hijos">Hijos</option> 
											<option value="Hermanos">Hermanos</option> 
											<option value="Cónyuge">Cónyuge</option>
											<option value="otro">Otros: ¿Cuál?</option>
										</select>
									</span>
								</fieldset>
								{
									parentesco === "otro" &&
									<fieldset>
										<label>Otro</label>
										<input type="text" value={otherParent} onChange={e=>{setOtherParent(e.target.value)}} maxLength={100} name='otherParent' id='otherParent' placeholder="" required/>
									</fieldset>
								}
							</div>
						</>
					}
					<input type="submit" id="submitFormUser" style={{display:"none"}} value="Send" />
					</form>
				</div>;
		case 1:
			return <>
				<div className="ce41BoxProcessInner">
					{_renderPlanes(dataPlanes, idPlanSelected, setIdPlanSelected)}
					<div name="errornamePlan" id='errornamePlan' className="errorField " style={{display: "none"}}>Por favor, seleccione un plan</div>
					<div className="ce41BoxProcessText">
						<form onSubmit={handleSubmit} name="formPlanDiscountNom">
							<div className="ce41BoxProcessChecks">
								<label className="checkbox">
									<input 
										type="checkbox"
										name='fiAutDescuentoNom'
										checked={fiAutDescuentoNom}
										onChange={(e)=>{setFiAutDescuentoNom(!fiAutDescuentoNom)}}
										required
									/>
									<span className="checkmark"></span>
									<span>{Parser(String(dataConfig.text_ACEPT_DESCUENTO_2))}</span>
								</label>
							</div>
							<input type="submit" id="submitFormPlan" style={{display:"none"}} value="Send" />
						</form>
					</div>
				</div>
			</>
		case 2:
			return <div className="ce41BoxProcessInner">
					{radiosModality}
					<div name="errornameModality" id='errornameModality' className="errorField " style={{display: "none"}}>Por favor, seleccione una modalidad</div>
				</div>;
		case 3:
			return <>
				<div className="ce41BoxProcessInner">
				<form onSubmit={handleSubmit} name="formUserOfTypeModality">
					{
						typeModalidad.toLowerCase().indexOf("nueva") <= -1 && typeModalidad.toLowerCase().indexOf("inclusi") <= -1 &&
						 !((idBanco === 5 || idBanco === 7) && esModalidadAdicional) &&
						<div className="fsOneCol">
							<fieldset>
								<label>* Operador actual</label>
								<span className="select">
									<select value={operatorSelected} onChange={(e)=>{setOperatorSelected(parseInt(e.target.value))}} name='operatorSelected' required>
										<option value="" disabled>Seleccionar</option>
										{optionsOperators}
									</select>
								</span>
								</fieldset>
						</div>
					}
				{/* Ajuste	 */}
				
				{
					  typeModalidad.toLowerCase().indexOf("nueva") <= -1 && idBanco !== 8 && ( (idBanco === 7) ? (
      						<div className="fsOneCol">
        						<fieldset>
          							<label>* Ingresa el número de contacto actual del empleado vinculado al Grupo Bancolombia</label>
										<input name="localTelefono" type="text" maxLength={10} onChange={validateOnlyNumbersComparador} value={localTelefono} required />
        						</fieldset>
      						</div>
   					 ) :   idBanco === 4 ? (
      						<div className="fsOneCol">
        						<fieldset>
          							<label>* Ingresa el número de celular a vincular en el convenio</label>
          								<input name="localTelefono" type="text" maxLength={10} onChange={validateOnlyNumbersComparador} value={localTelefono} required/>
        						</fieldset>
      						</div>
    				) : idBanco === 5 ? (
      						<div className="fsOneCol">
        						<fieldset>
          							<label>* Ingresa el número de contacto actual del empleado vinculado al convenio del fondo</label>
          								<input name="localTelefono" type="text" maxLength={10} onChange={validateOnlyNumbersComparador} value={localTelefono} required/>
        						</fieldset>
      						</div>
    				      ) : idBanco === 6 ? (
                           <div className="fsOneCol">
								<fieldset>
									<label>* Ingresa el número celular:</label>
									<input name="localTelefono"type="text"maxLength={10}onChange={validateOnlyNumbersComparador}value={localTelefono}required/>
								</fieldset>
						     </div>
						) : (
							<div className="fsOneCol">
							<fieldset>
								<label>
									{idBanco === 18 ? "* Ingresa el número de celular actual:" : "* Ingresa el número de celular actual de tu familiar:"}
								</label>
								<input name="localTelefono"type="text"maxLength={10}onChange={validateOnlyNumbersComparador}value={localTelefono}required/>
							</fieldset>
							</div>
    					)
  					)
				}

				{
					typeModalidad.toLowerCase().indexOf("nueva") > -1 && (idBanco === 5) && (
						<div className="fsOneCol">
						<fieldset>
							<label>* Ingresa el número de contacto actual del empleado vinculado al convenio del fondo</label>
							<input 
							name="localTelefono" 
							type="text" 
							maxLength={10} 
							onChange={validateOnlyNumbersComparador} 
							value={localTelefono} 
							required 
							/>
						</fieldset>
						</div>
					)
					}
					{
					typeModalidad.toLowerCase().indexOf("nueva") > -1 && (idBanco === 7) && (
						<div className="fsOneCol">
						<fieldset>
							<label>* Ingresa el número de contacto actual del empleado vinculado al Grupo Bancolombia</label>
							<input 
							name="localTelefono" 
							type="text" 
							maxLength={10} 
							onChange={validateOnlyNumbersComparador} 
							value={localTelefono} 
							required 
							/>
						</fieldset>
						</div>
					)
					}

					
					
					{
						<div className="fsOneCol">
							{
							dataConfig.visible_INPUT_NOMBREEMPLEADO === 'true' &&
                             mostrarDatosEmpleado ?
								<fieldset>
									<label>*Nombre completo del empleado vinculado al Grupo Bancolombia</label>
									<input type="text" value={nombreEmpleado} onChange={e=>{setNombreEmpleado(e.target.value)}} maxLength={100} name='nombreEmpleado' id='nombreEmpleado' placeholder="Nombre completo del empleado vinculado al Grupo Bancolombia" required/>
								</fieldset>  
							 :null
							}   
						</div>
					}
					{
                        <div className="fsOneCol">               
						{
						 dataConfig.visible_INPUT_CEDULAEMPLEADO === 'true' &&
                            mostrarDatosEmpleado ?
						 
							 <fieldset>
								 <label>*Número de cédula del empleado vinculado al Grupo Bancolombia</label>
								 <input type="text" value={cedulaEmpleado} onChange={e=>{setCedulaEmpleado(e.target.value)}} maxLength={100} name='cedulaEmpleado' id='cedulaEmpleado' placeholder="Número de cédula del empleado vinculado al Grupo Bancolombia" required/>
							 </fieldset>  
		   
						 :null
						 }
				       </div>
					}
					{
						(
							typeModalidad.toLowerCase().includes("nueva") ||
							typeModalidad.toLowerCase().includes("portabilidad")
						) &&
						(
							idBanco === 7 ||
							idBanco === 4
						) && (
							<>
							<div className="fsOneCol">
								<fieldset>
									<label htmlFor="fc_tipo_sim">
										*¿Qué tipo de SIM card necesitas para la activación de tu línea?
									</label>

									<select
										value={fc_tipo_sim}
										onChange={(e) => setFcTipoSim(e.target.value)}
										name="fc_tipo_sim"
										id="fc_tipo_sim"
										required
									>
										<option value="" disabled>
											Seleccionar
										</option>

										<option value="SIM física (Chip de plástico)">
											SIM física (Chip de plástico)
										</option>

										<option value="eSIM (SIM virtual / Código QR)">
											eSIM (SIM virtual / Código QR)
										</option>
									</select>
								</fieldset>

								
							</div>
                            <div
								className="fsOneCol"
								style={{
									fontSize: "12px",
									color: "#6c757d",
									marginTop: "6px",
									lineHeight: "1.4",
									fontStyle: "italic"
								}}
							>
								Verifica que tu teléfono sea compatible con la tecnología eSIM antes de elegir esta opción.
							</div>

							</>
							
						)
					}
					{
						dataConfig.visible_INPUT_ENTIDAD  === 'true' ?
					<div className="fsOneCol">
						<fieldset>
							<label>* Entidad a la que perteneces</label>
							<span className="select">
								<select value={entitySelected} onChange={ (e) => {setEntitySelected(parseInt(e.target.value))}} name='idEntityUser' required>
									<option value="" disabled>Seleccionar</option>
									{optionsEntities}
								</select>
							</span>
							</fieldset>
					</div>
					: null
					}
						{
							// cambio d elugar id 7
							<div className="fsOneCol">
								{(idBanco === 7) ||
  (idBanco === 5 && esModalidadAdicional) ? (
									<fieldset>
										<label>Correo Electrónico Corporativo</label>
										<input type="email" value={emailUser} onChange={e => { setEmailUser(e.target.value) }} maxLength={50} name='emailUser' id='emailUser' placeholder="ejemplo@banco.com" required />
									</fieldset>

								) : (

									<fieldset style={{ display: "none" }}>
										<label>Correo Electrónico Corporativo</label>
										<input type="email" value={emailUser} onChange={e => { setEmailUser(e.target.value) }} maxLength={50} name='emailUser' id='emailUser' placeholder="ejemplo@banco.com" required />
									</fieldset>
								)}
							</div>

						}

					{
						typeModalidad.toLowerCase().indexOf("inclusi") <= -1 && 
						<div className="fsOneCol">
							<fieldset>
							<div>
								{
									dataConfig.visible_INPUT_DIRECCIONSIMCAR === 'true' ?
										<fieldset>
											<label>*Ingresa la dirección donde requieras recibir la Sim Car</label>
											<input type="text" value={insertSimCar} onChange={e=>{setInsertSimCar(e.target.value)}} maxLength={100} name='insertSimCar' id='insertSimCar' placeholder="Ingresa la direccion donde requieras recibir la Sim Car" required/>
										</fieldset>  
										
										  
									:null
								}

                             </div>
							<br></br>
							<div>
								{
									dataConfig.visible_INPUT_CIUDAD === 'true' ?
										<fieldset>
											<label>*Ciudad / Municipio</label>
											<input type="text" value={cityUser} onChange={e=>{setCityUser(e.target.value)}} maxLength={100} name='cityUser' id='cityUser' placeholder="Escriba su ciudad" required/>
										</fieldset>
									:null
								}
							</div>
							<br></br>
							<div>
								{
									dataConfig.visible_INPUT_BARRIO === 'true' ?
										<fieldset>
											<label>*Barrio</label>
											<input type="text" value={barrioUser} onChange={e=>{setBarrioUser(e.target.value)}} maxLength={100} name='barrioUser' id='barrioUser' placeholder="Escriba su barrio" required/>
										</fieldset>
                                 	:null
								}
								
							</div>
							</fieldset>
						</div>
					}
					<div className="fsOneCol">
						<fieldset>
						<div className="fsOneCol" > 
							  {
								dataConfig.visible_INPUT_NIT === 'true' ?
									<fieldset>
										<label>*NIT</label>
										<input type="text" value={nit} onChange={e=>{setNit(e.target.value)}} maxLength={10} name='nit' id='nit' placeholder="Escriba su NIT" required/>
									</fieldset>
								:null
							  }
									
							   </div>
						</fieldset>
					</div>
					<input type="submit" id="submitFormUserModality" style={{display:"none"}} value="Send" />
				</form>
				</div>
				<div className="ce41BoxProcessNote">
					<p> * Enviaremos al domicilio que registraste la nueva Sim Card</p>
				</div>
			</>
		case 4:
			return <div className="ce41BoxProcessInner">
					<div className="ce41BoxProcessText">
						<h3>{dataConfig.title_BOX_PROCESS_5}</h3>
						{Parser(String(txtTerms5))}
						<div className="ce41BoxProcessChecks">
							<form onSubmit={handleSubmit} name="formUserAuth">
								<label className="checkbox">
									<input 
										type="checkbox"
										name='fiAceptaContrato'
										checked={fiAceptaContrato}
										onChange={(e)=>{setFiAceptaContrato(!fiAceptaContrato)}}
										required
									/>
									<span className="checkmark"></span>
									<span>{dataConfig.text_ACEPT_CONTRATO_5}</span>
								</label>
								<label className="checkbox">
									<input 
										type="checkbox"
										name='fiFactElec'
										checked={fiFactElec}
										onChange={(e)=>{setFiFactElec(!fiFactElec)}}
										required
									/>
									<span className="checkmark"></span><span>{dataConfig.text_ACEPT_FACTURA_5}</span>
								</label>
                                <div className="recaptcha-container" style={{ paddingTop: "12px" }}>
								<ReCAPTCHA
									sitekey={SITE_KEY}
									onChange={(value) => {
										console.log("Captcha value:", value);
										setCaptchaValue(value);
										const captchaError = document.querySelector('.recaptcha-container .errorField');
										if (value && captchaError) {
										captchaError.remove(); 
										}
									}}
						         />
								 </div>
								<input type="submit" id="submitFormUserAuth" style={{display:"none"}} value="Send" />
							</form>
						</div>
					</div>
					<div>
						</div>
				</div>;
		default:
			return "No Content";
	}
}


function CE41CompaniesOrg(props) {
	const {
		dataConfig,
		txtTerms5,
		dataOfBanks,
		idBanco,
		dataPlanes,
		dataDocumentTypes,
		dataDepartments,
		dataEntities,
		dataOperators,
		dataModalities,
	} = props;

	// var
	const [activeStep, setActiveStep] = useState(0);
	const [status, setStatus] = useState(STATUS.STEPS)
	const steps = ["Step1", "Step2", "Step3", "Step4", "Step5"];

	
	const [nameUser, setNameUser] = useState('')
	const [phoneUser, setPhoneUser] = useState('')
	const [idDocumentType, setIdDocumentType] = useState('')
	const [noDocument, setNoDocument] = useState('')
	const [emailUser, setEmailUser] = useState('')
	const [birthDateUser, setBirthDateUser] = useState('')
	const [expediDataUser, setExpediDataUser] = useState('')
	const [nombreEmpleado, setNombreEmpleado] = useState('')
	const [cedulaEmpleado, setCedulaEmpleado] = useState('')
	const [insertSimCar, setInsertSimCar] = useState('')
	const [nit, setNit] = useState('')
	const [camaraComercio, setCamaraComercio] = useState ('')
	const [addressUser, setAddressUser] = useState('')
	const [cityUser, setCityUser] = useState('')
	const [idDeparment, setIdDeparment] = useState('')
	const [barrioUser, setBarrioUser] = useState('')
	const [parentesco, setParentesco] = useState('')
	const [otherParent, setOtherParent] = useState('')

	const [idPlanSelected, setIdPlanSelected] = useState('')

	const [typeModalidad, setTypeModalidad] = useState('')
	const [modalitySelected, setModalitySelected] = useState('')

	const [localTelefono, setLocalTelefono] = useState('')
	const [operatorSelected, setOperatorSelected] = useState('')
	const [entitySelected, setEntitySelected] = useState('')
	const [fc_tipo_sim, setFcTipoSim] = useState('');

	const [idSolicitud, setIdSolicitud] = useState(0)
	const [disabledContinua, setDisabledContinua] = useState(false)

	const [fiAceptaContrato, setFiAceptaContrato] = useState(false)
	const [fiFactElec, setFiFactElec] = useState(false)
	const [fiAutDescuentoNom, setFiAutDescuentoNom] = useState(false)
	const [captchaValue, setCaptchaValue] = useState(null);


	useEffect(()=>{
		console.log("prevActiveStep", activeStep)
		if(activeStep === 0){
			validForm('formUserInfo')
		}
		if(activeStep === 1){
			validForm('formPlanDiscountNom')
		}
		if(activeStep === 3){
			validForm('formUserOfTypeModality')
		}
		if(activeStep === 4){
			validForm('formUserAuth')
		}
	})

	// Fuctions
	const handleNext = () => {
		let next = true
		var objectsErrors = []

		if(activeStep === 0){
			$('#submitFormUser').trigger( "click" );
			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				next = false
			}
		}
		if(activeStep === 1){
			$('#submitFormPlan').trigger( "click" );
			$('#errornamePlan').hide()

			if(idPlanSelected ===""){
				$('#errornamePlan').show()
				next = false
			}

			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				next = false
			}
			console.log("submitFormPlan", next, idPlanSelected)
		}

		if(activeStep === 2){
			$('#errornamePlan').hide()
			if(typeModalidad === ''){
				$('#errornameModality').show()
				next = false
			}
		}
		if(activeStep === 3){
			$('#submitFormUserModality').trigger( "click" );
			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				next = false
			}
		}

		if(next){
			setActiveStep((prevActiveStep) => prevActiveStep + 1);
		}
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};
	const handleFinish = () => {
		let finish = true
		var objectsErrors = []
	
		if (!captchaValue) {
			const captchaElement = document.querySelector('.recaptcha-container');
			if (captchaElement) {
				let captchaError = captchaElement.querySelector('.errorField');
				if (!captchaError) {
					captchaError = document.createElement('span');
					captchaError.className = 'errorField';
					captchaError.textContent = "Completa el captcha";
					captchaElement.appendChild(captchaError);
				}
			}
		} else {
			const captchaError = document.querySelector('.recaptcha-container .errorField');
			if (captchaError) {
				captchaError.remove();
			}
		} 
		setDisabledContinua(true)
		if(activeStep === 4){
			$('#submitFormUserAuth').trigger( "click" );
			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				finish = false
				setDisabledContinua(false)
			}
		}
		if(finish){
			submintFormReques()
		}
		// setStatus(STATUS.SUCCESS);
	};
	const handleAplication = () => {
		// setStatus(STATUS.APPLICATION);
		window.location.reload();
	};

	const handleSubmit = event => {
		console.log('handleSubmit ran');
		event.preventDefault(); // 👈️ prevent page refresh
	};

	function validateOnlyNumbersComparador(e) {
        // clearClassStatusPlanComparador()
        let regex = /^[0-9\b]+$/;
        let inputVal = e.target.value
        if ( inputVal === '' || (regex.test(inputVal) && (inputVal.startsWith("3"))) ) {
            // console.log("numberssssssssssssssssssssss::::::" + inputVal)
            setLocalTelefono(inputVal)
        }
    }

	async function submintFormReques(){
		let id_sin_operador = localStorage.getItem("id_sin_operador") ? localStorage.getItem("id_sin_operador") : 1 
		var entidad = entitySelected;

		var sim = '';
		sim=fc_tipo_sim;
		
		if(entitySelected === '') {
			entidad =  dataEntities[0].fi_id;
			setEntitySelected(dataEntities[0].fi_id)
		}		
		console.log('entidad:::::::', entidad);
		console.log('sim value:::::::', sim);
		const dataBody ={
			"fc_nombres" : nameUser,
			"fc_telefono" : phoneUser,

			"fi_tipo_doc" : idDocumentType,
			"fc_num_doc" : noDocument,

			"fc_email" : emailUser,
			"fd_fecha_nacimiento" : birthDateUser,
			
			"fc_direccion_res" : addressUser,
			"fc_ciudad" : cityUser,

			"fi_depto" : idDeparment,
			"fc_barrio" : barrioUser,
			
			"fd_fecha_expedicion" : expediDataUser,
			"fc_camara_comercio": camaraComercio,

			"fc_parentesco" : parentesco === "otro" ? otherParent : parentesco,
			
			"fi_plan" : idPlanSelected,
			"fi_banco" :  idBanco,
			"fi_plan_bco" : idPlanSelected,
			
			//crear variable para ir solo se tiene el texto: typeModalidad
			"fi_modalidad" : modalitySelected,
			
			"fi_operador" : operatorSelected === "" ? id_sin_operador : operatorSelected,
			"fc_num_actual" : localTelefono,
			"fi_entidad" : entidad,
			"fc_direccionsimcar": insertSimCar,
			"fc_ciudad_municipio": cityUser,
			"fc_nombre_empleado":nombreEmpleado,
			"fc_cedula_empleado":cedulaEmpleado,
			"fc_barrio_lineanueva": barrioUser,
			"fc_nit": nit,
			
			//valores de checks ultima página
			"fi_acepta_contrato" : fiAceptaContrato ? 1 : 0,
			"fi_fact_elec" : fiFactElec ? 1 : 0,

			"fc_direccion_entrega" : "",

			//agregar check en pantalla de plan de autorización de descuento en nomina
			"fi_aut_descuento_nom" : fiAutDescuentoNom ? 1 : 0,
			"fc_tipo_sim" : fc_tipo_sim,

			"captchaResponse" : captchaValue,
			
		}
		var jsonSendData = JSON.stringify(dataBody);
		const RegistraSolicitud = await registerRequestService.RegisterRequestItem(jsonSendData);
		console.log("submintFormReques ", RegistraSolicitud)
		if(RegistraSolicitud){
			setIdSolicitud(parseInt(RegistraSolicitud))
			setStatus(STATUS.SUCCESS);
		}else{
			
			setDisabledContinua(false)
			// setStatus(STATUS)
		}
	}

	const radiosModality = dataModalities?.length ? dataModalities.filter(dataModal => dataModal.fc_tipo_servicio !== "HOG").map((mod, index)=>(
		<div className="ce41BoxRadio ce41BoxRadio2" key={uuid()}>
			<input 
				type="radio"
				name="rad1"
				value={mod.fc_titulo} 
				onChange={e=>{setTypeModalidad(mod.fc_titulo); setModalitySelected(parseInt(mod.fi_id))}}
				checked={mod.fi_id === modalitySelected ? true : false}
			/>
			<span className="checkbg"></span>
			<span className="checkmark"></span>
			<div className="ce41BoxRadioInner">
				<h3>{mod.fc_titulo}</h3>
				{
					mod?.fc_descripcion &&
					<p>
						{mod?.fc_descripcion}
					</p>
				}
			</div>
			<div className="ce41BoxRadioPicture">
				<i className={`${mod.fc_clase_icono}`}></i>
			</div>
		</div>
	)) : null;

	const setNumberValid = value => {
        if (/^[0-9]+$/.test(value) !== true && value.length > 0) {
            return;
        }
        if (value === '' || value.startsWith("3")) {
            setPhoneUser(value)
        } else{
			return;
        }
    }

	const setNumberValidDocument = value => {
        if (/^[0-9]+$/.test(value) !== true && value.length > 0) {
            return;
        }
        setNoDocument(value)
    }

	console.log("idBanco:Toma Ajustes Con Fecha de Hoy Ajuste Campo ::::::::::::" + idBanco);
	return (
		<section className="ce41">
			{ status === STATUS.STEPS ? 
				<div className="container">
					<div className="ce41Title">
						<h2>{dataConfig.title_CONTENT}</h2>
						<p>{dataConfig.description_CONTENT}</p>
					</div>
					<div className="ce41Box">
						<div className="ce41BoxSteps">
							{getStepInfo(activeStep, dataConfig)}
							<div className="ce41BoxStepsIndicator">
								<span className={activeStep >= 0 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep >= 1 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep >= 2 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep >= 3 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep === 4 ? "active" : "normal"}>&nbsp;</span>
							</div>
						</div>
						<div className="ce41BoxProcess">
							{
								getStepContent(
									activeStep,
									dataConfig,
									txtTerms5,
									dataOfBanks,
									dataPlanes,
									dataDocumentTypes,
									dataDepartments,
									dataEntities,
									dataOperators,
									localTelefono,
									validateOnlyNumbersComparador,
									nameUser,
									setNameUser,
									phoneUser,
									setNumberValid,
									idDocumentType,
									setIdDocumentType,
									noDocument,
									setNumberValidDocument,
									emailUser,
									setEmailUser,
									birthDateUser,
									setBirthDateUser,
									expediDataUser,
									setExpediDataUser,
									nit,
									setNit,
									insertSimCar,
									setInsertSimCar,
									nombreEmpleado,
									setNombreEmpleado,
									cedulaEmpleado,
									setCedulaEmpleado,
									camaraComercio,
									setCamaraComercio,
									addressUser,
									setAddressUser,
									cityUser,
									setCityUser,
									idDeparment,
									setIdDeparment,
									barrioUser,
									setBarrioUser,
									parentesco,
									setParentesco,
									otherParent,
									setOtherParent,
									idPlanSelected,
									setIdPlanSelected,
									typeModalidad,
									radiosModality,
									operatorSelected, setOperatorSelected,
									fc_tipo_sim, setFcTipoSim,
									entitySelected, setEntitySelected,
									fiAutDescuentoNom, setFiAutDescuentoNom,
									fiAceptaContrato, setFiAceptaContrato,
									setCaptchaValue,
									fiFactElec, setFiFactElec,
									handleSubmit,
									idBanco,

								)
							}
						</div>
					</div>
					<div className={activeStep === 0 ? "ce41Buttons right" : "ce41Buttons"}>
						{activeStep === 0 ? "" : <button className="btn btnNegro" onClick={handleBack}>Regresar</button>}
						{activeStep < (steps.length - 1) ? <button className="btn btnPrimario" onClick={handleNext}>Siguiente</button> : ""}
						{/* <button className="btn btnPrimario" onClick={handleNext}>
							{activeStep === steps.length - 1 ? "Finalizar" : "Siguiente"}
						</button> */}
						{
						activeStep === steps.length - 1 ?
							<button className="btn btnPrimario" onClick={handleFinish} disabled={disabledContinua} >{disabledContinua ? "Enviando..." : "Finalizar"}</button>
							: ""
						}
					</div>
				</div>
				:""
			}
			{ status === STATUS.SUCCESS ? 
				idSolicitud!==-208?
				<>
					<div className="container">
						<div className="ce41SuccesTitle">
							<i className="ico-check-circle"></i>
							<h2 className="h2">
								Has finalizado tu proceso exitosamente
							</h2>
						</div>
						<div className="ce41SuccesBox">
							<div className="ce41SuccesCont">
								{
								 idBanco &&
									<p className="ce41SuccesContTitle"> 
									{dataConfig.title_GRACIAS}
									</p>
										
								}
								
								<p>
									Enviaremos a tu correo electrónico una copia del contrato que acabas de diligenciar y los pasos a seguir para la activación de tu plan.
								</p>
								{
									idSolicitud &&
									<p className="ce41SuccesContTitle">Número de solicitud: {idSolicitud}</p>
								}
							</div>
							<div className="ce41SuccesActions">
								<button className="btn btnPrimario" onClick={handleAplication}>Volver a Inicio</button> 
							</div>
						</div>
					</div>
				</>
				:<>
				<div className="container">
					<div className="ce41SuccesTitle">
						
						<h2 className="h2">
						      Error al procesar la solicitud
						</h2>
					</div>
					<div className="ce41SuccesBox">
						<div className="ce41SuccesCont">
							
							<p>
							 Has excedido el número de intentos con el número de cédula registrado.
							</p>
						
						</div>
						<div className="ce41SuccesActions">
							<button className="btn btnPrimario" onClick={handleAplication}>Volver a Inicio</button> 
						</div>
					</div>
				</div>
			     </>
				:""
			}
		
		</section>
		
	)
	
}

export default CE41CompaniesOrg